<template>
  <div class="table-responsive" ref="table">
    <dynamic-table :columns="assignedReviewersColumns"
                   :data="assignedReviewers"
                   :loading="loading"
                   class="table-hover"
                   empty-message="No se han asignado revisores.">
      <template v-slot:researcher_status_key="slotProps">
                          <span :class="showReviewerStatus(slotProps.row.researcher_status_key).class"
                                class="badge">{{ showReviewerStatus(slotProps.row.researcher_status_key).title }}</span>
      </template>
      <template v-slot:actions="slotProps">
        <div class="list-group-item-figure align-items-start justify-content-center">
          <div class="dropdown">
            <button aria-expanded="false" class="btn btn-sm btn-icon btn-light"
                    data-toggle="dropdown">
              <i class="fa fa-fw fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" style="">
              <div class="dropdown-arrow mr-n1"></div>
              <button class="dropdown-item" type="button"
                      data-toggle="modal"
                      data-target="cancel-protocol"
                      :disabled="slotProps.row.researcher_status_key !== 'aceptado'"
                      @click="$emit('resend-invitation', slotProps.row.user_id)">
                Volver a invitar
              </button>
            </div>
          </div>
        </div>
      </template>
    </dynamic-table>
  </div>
</template>

<script>
  import DynamicTable from '../../ui/DynamicTable'
  import { mapActions, mapGetters } from 'vuex'
  
  export default {
    name: 'AssignedReviewersProtocol',
    components: {
      DynamicTable,
    },
    props: {
      protocol: Object,
      committee: Object,
      amendment: Object,
    },
    data() {
      return {
        loading: true,
        assignedReviewersColumns: [
          {
            field: 'full_name',
            title: 'Nombre',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'actions',
            title: 'Acciones',
            tdClass: 'align-middle text-center',
            tdStyle: {},
            thClass: 'align-middle text-center',
            thStyle: {},
          },
        ],
      }
    },
    methods: {
      ...mapActions({
        getAssignedReviewers: 'committees/getAssignedReviewers',
      }),
      
      async load() {
        this.loading = true
        
        const { committee, protocol, amendment } = this
        
        await this.getAssignedReviewers({
          protocol,
          committee,
          amendment,
        })
        
        this.loading = false
      },
      openCommentsModal(comments) {
        this.$emit('show-comments', comments)
      },
      showReviewerStatus(key) {
        const titleStatuses = {
          enviado: {
            title: 'Pendiente por investigador',
            class: 'badge-primary',
          },
          aceptado: {
            title: 'Investigador aceptó invitación',
            class: 'badge-success',
          },
          rechazado: {
            title: 'Investigador rechazó invitación',
            class: 'badge-warning',
          },
          cancelado: {
            title: 'El comité canceló la invitación',
            class: 'badge-subtle badge-danger',
          },
          default: {
            title: 'El comité canceló la invitación',
            class: 'badge-subtle badge-dark',
          },
        }
        
        if(key in titleStatuses) {
          return titleStatuses[key]
        }
        
        return titleStatuses.default
      },
    },
    computed: {
      ...mapGetters({
        assignedReviewers: 'committees/assignedReviewers',
      }),
    },
    async mounted() {
      await this.load()
    },
  }
</script>
